import dayjs from 'dayjs'

import utc from 'dayjs/esm/plugin/utc'
import timezone from 'dayjs/esm/plugin/timezone'

// @ts-ignore
dayjs.extend(timezone)
// @ts-ignore
dayjs.extend(utc)

export function useDateFormat() {
  function currentDifference(a: string | number, unit = '') {
    const date1 = dayjs(a)
    const date2 = dayjs()
    return date1.diff(date2, unit)
  }
  function difference(a: string, b: string) {
    const date1 = dayjs(a)
    const date2 = dayjs(b)
    return date1.diff(date2)
  }
  function formatDate(date: string | number, format = 'YYYY-MM-DD') {
    if (!date) return ''
    return dayjs(date).format(format)
  }
  function formatDateToString(date: string) {
    if (!date) return ''
    return dayjs(date).format('MMM DD YYYY')
  }

  function formatDateToMinutes(date: string) {
    if (!date) return ''
    return dayjs(date).format('MM/DD/YYYY hh:mm a')
  }
  function dateNow(
    format: string = 'YYYY-MM-DD',
    options = { addMin: 0, timeZone: dayjs.tz.guess() }
  ) {
    const currentTime = new Date(new Date().getTime() + options.addMin * 60000)

    return dayjs(currentTime).tz(options.timeZone).format(format)
  }
  return {
    formatDate,
    formatDateToString,
    formatDateToMinutes,
    dateNow,
    difference,
    currentDifference,
  }
}

export function formatString() {
  function toPascalCase(str: string) {
    if (!str) return ''
    return str.replace(
      /\w\S*/g,
      (m: any) => m.charAt(0).toUpperCase() + m.substr(1).toLowerCase()
    )
  }
  return {
    toPascalCase,
  }
}
